import {RouteDefine} from "../../routes/RouteDefine";

export type OnboardingStep = 1 | 2 | -1;

export const isAdminAccount = (payload: {
    user?: {is_admin?: number | boolean | string | null} | null;
} | null | undefined): boolean =>
    Number(payload?.user?.is_admin ?? 0) === 1;

/**
 * Resume destination after login / marketplace return.
 * 1 = Connect Stripe (/confirm)
 * 2 = Setup wizard (/setup)
 * -1 = App (dashboard)
 */
export const resolveOnboardingPath = (payload: {
    step?: number | null;
    user?: {
        is_admin?: number | boolean | string | null;
        is_logged?: number | boolean | null;
        setup?: {stripe_access_token?: string | null} | null;
    } | null;
}): string => {
    if (isAdminAccount(payload)) {
        return RouteDefine.admin;
    }

    const step = resolveOnboardingStep(payload);
    if (step === 1) {
        return RouteDefine.confirm;
    }
    if (step === 2) {
        return RouteDefine.setup;
    }
    return RouteDefine.dashboard;
};

export const resolveOnboardingStep = (payload: {
    step?: number | null;
    user?: {
        is_admin?: number | boolean | string | null;
        is_logged?: number | boolean | null;
        setup?: {stripe_access_token?: string | null} | null;
    } | null;
}): OnboardingStep => {
    if (isAdminAccount(payload)) {
        return -1;
    }

    if (payload?.step === 1 || payload?.step === 2 || payload?.step === -1) {
        return payload.step;
    }

    const hasStripe = Boolean(payload?.user?.setup?.stripe_access_token);
    const isLogged = Boolean(Number(payload?.user?.is_logged ?? 0));

    if (!hasStripe) {
        return 1;
    }
    if (!isLogged) {
        return 2;
    }
    return -1;
};
